<template>
  <div class="audit-panel">
    <button
      type="button"
      class="audit-toggle"
      :aria-expanded="open ? 'true' : 'false'"
      @click="open = !open"
    >
      <span class="audit-label">Audit Trail</span>
      <span class="audit-count">{{ audit.length }}</span>
      <b-icon-chevron-down class="audit-chevron" :class="{ open: open }" />
    </button>
    <b-collapse :visible="open">
      <div
        v-for="(entry, i) in audit"
        :key="i"
        class="audit-entry"
        :class="{ 'audit-entry-first': i === 0 }"
      >
        <b-badge
          pill
          :variant="auditActionVariant(entry.action)"
          class="mr-2 mt-1 text-capitalize flex-shrink-0"
        >
          {{ entry.action }}
        </b-badge>
        <span class="text-muted audit-entry-text">
          <span>{{ entry.by }}</span>
          <span class="audit-entry-datetime">
            · {{ formatAuditDateTime(entry.at) }}
          </span>
          <span v-if="entry.note"> - {{ entry.note }}</span>
        </span>
      </div>
    </b-collapse>
  </div>
</template>

<script>
import {
  auditActionVariant,
  formatAuditDateTime,
} from '@/utils/timesheetHelpers'

export default {
  name: 'SupervisorAuditTrail',
  props: {
    audit: { type: Array, required: true },
  },
  data() {
    // Collapsed by default (fix for the audit trail sitting permanently
    // open at the bottom of every timesheet card) — tucked behind a
    // dropdown toggle instead.
    return { open: false }
  },
  methods: {
    auditActionVariant,
    formatAuditDateTime,
  },
}
</script>

<style lang="scss" scoped>
/* Moved from SupervisorTimesheetTab.vue's scoped style, which used to
   render this markup inline — Vue scoped CSS only reaches a child
   component's root element, never its internal nodes, so none of these
   rules ever applied once this panel was split into its own component
   (commit 3d53908). Now shared by SupervisorTimesheetTab, TeamTimesheetTab
   and SupervisorSubmitHistory, which used to each carry their own copy of
   this markup inline instead of using this component. */
.audit-panel {
  margin-bottom: 1rem;
  padding: 0.6rem 0.85rem;
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  background: #ffffff;
}

.audit-toggle {
  display: flex;
  align-items: center;
  gap: 0.4rem;
  width: 100%;
  padding: 0.25rem 0;
  background: none;
  border: none;
  cursor: pointer;
  text-align: left;
}

.audit-label {
  color: #6b7280;
  font-size: 0.72rem;
  font-weight: 800;
  letter-spacing: 0.05em;
  text-transform: uppercase;
}

.audit-count {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 18px;
  height: 18px;
  padding: 0 5px;
  border-radius: 999px;
  font-size: 11px;
  font-weight: 700;
  background: #f3f4f6;
  color: #6b7280;
}

.audit-chevron {
  margin-left: auto;
  color: #9ca3af;
  transition: transform 0.2s;

  &.open {
    transform: rotate(180deg);
  }
}

.audit-entry {
  display: flex;
  align-items: flex-start;
  gap: 0.45rem;
  margin-top: 0.55rem;
  color: #6b7280;
  font-size: 0.8rem;
}

.audit-entry-first {
  margin-top: 0.7rem;
  padding-top: 0.6rem;
  border-top: 1px dashed #e5e7eb;
}

/* Name and "· date, time" wrap as whole chunks instead of breaking
   mid-word on narrow cards. min-width: 0 lets the row actually shrink to
   the card's width instead of overflowing past its edge — the time/am-pm
   pair itself is kept together via a non-breaking space in
   formatAuditDateTime() rather than a hard nowrap here. */
.audit-entry-text {
  display: flex;
  flex-wrap: wrap;
  column-gap: 4px;
  min-width: 0;
  flex: 1 1 auto;
}

.audit-entry-datetime {
  min-width: 0;
}
</style>
